import { Namespace } from '../../../../../../../translation/namespace';
import { Linkchooser } from './Linkchooser';
import { onSetupLink, unlink } from './utilities';

export const linkchooserPlugin = {
  title: `${Namespace.Linkchooser}:title`,
  name: 'linkchooser',
  shortcut: 'shift+alt+l',
  icon: 'link',
  Component: Linkchooser,
  additionalMenuCommands: [
    {
      title: `${Namespace.Linkchooser}:unlink.title`,
      name: 'unlink',
      icon: 'unlink',
      onAction: unlink,
      onSetup: onSetupLink,
    },
  ],
  additionalToolBarCommands: [
    {
      title: `${Namespace.Linkchooser}:unlink.title`,
      name: 'unlink',
      icon: 'unlink',
      onAction: unlink,
      onSetup: onSetupLink,
    },
  ],
};
